module.exports = {
	
	
	
	
  'tmbTmbsContent': [[
    {'label': '123'}
  ]],
  
	'newList': [[
		{
			'newid': '1',
			'title': '智立方深耕工业自动化设备，研发投入已超6700万',
			'date': '2022-02-09 17:10:29',
			'substance': '为今年过会的第18家企业，深圳市智立方自动化设备股份有限公司或将于年内正式登陆创业板。成立于2011年的智立方，属于高端装备制造行业，是一家专注于工业自动化设备的研发、生产、销售及相关技术服务的高新技术企业，为下游客户智能制造系统、精益和自动化生产体系提供定制化专业解决方案。',
			'topimg': 'news1.png',
			'template':'<p>公司核心业务为自动化测试设备及自动化组装设备业务，产品包括工业自动化设备、自动化设备配件及相关技术服务，主要应用于光学、电学、力学等功能测试环节，以及消费电子、电子烟、工业电子、汽车电子、半导体等领域产品的组装环节，帮助客户实现生产线的半自动化和全自动化，提高生产效率和产品良品率。</p><p>2013年，智立方被评定为“双软企业”；自2014年起，公司被持续认定为高新技术企业。这意味着公司在行业内的创新、研发能力有目共睹。</p><p>自成立以来，智立方始终将新技术、新产品研发作为企业维持核心竞争力关键保障，高度重视技术研发投入与创新，从而保证企业在相关领域始终维持较强的市场竞争地位。近年来，公司不断加大研发投入力度，提供大量资金与人力进行技术开发与产品改造升级。</p><p>截至报告期末，公司研发及技术人员共184人（包括非研发部门技术人员），占公司员工总数的40.62%。研发费用投入持续占营收比稳定在7%以上。</p><p>凭借雄厚的技术实力与研发力量，公司先后被广东省科学技术厅、广东省知识产权保护协会认定为“广东省微电子精密封装及测试工程技术研究中心”、“2020年度广东省知识产权示范企业”。目前，公司及子公司拥有专利57项，软件著作权46项，软件产品证书6项。</p><p>此外，为了保持公司研发活力，除了稳定的研发资金投入外，公司还建立建全了可持续发展的技术创新机制。</p><p>在人才建设与培养机制上，一方面，公司不断引进国内外高端人才，为现有人才队伍注入新的活力，保持团队的持久创新力；另一方面，公司不断完善内部人才培养和管理体制，改进和创新内部人才的培养开发、选拔任用、流动配置和激励保障等机制，激发员工积极性。</p><p>在技术创新机制上。公司建立了灵活、高效的研发体系，密切跟踪行业发展趋势，快速满足客户产品技术变化，准确把握市场需求提前布局技术研发，做到快速响应、高效高质产出技术成果。</p><p>另外公司还构建了多层次激励机制，对研发人员建立了一套较为有效的绩效评价标准和公平公正的薪酬分配体系。</p>',
		},
		{
			'newid': '2',
			'title': '2022郑州工业自动化展：工业机器人行业痛点分析与发展趋势',
			'date': '2021-12-03 09:36',
			'substance': "工业机器人是“制造业皇冠顶端的明珠”，对其研发、制造、应用的能力，是衡量一个国家科技创新与高端制造水平的重要标志，也是未来我们迈向制造强国的必由途径，了解我国目前工业机器人处于一个什么样的水平，与国外差距如何，又存在何等难以解决的痛点，未来的发展趋势是怎样的等等问题，才能做出更加准确的决策，让有限的资源产出最大的价值，以提高整个行业在全球的竞争力。",
			'topimg': 'news2.png',
			'template': '<h5>工业机器人行业痛点分析与发展趋势</h5><h3>1、工业机器人行业痛点</h3><p>一是人才极度缺乏。经过多年的努力发展，如今我国制造业已经跨过了第一阶段的劳动密集型产业、第二阶段的资本密集型产业，来到了第三阶段的智力密集型产业，也就是高端制造，在这一阶段，行业对人才的定位已经改变了，也就是说现今的大多数人才，与接下来行业的需求并不匹配，导致出现人才极度缺乏的状况。</p><p>从最基本的操作和编程，到整个机器人系统的复杂调试、维护，我们在研究人才、工程人才、操作人才等全方位存在稀缺痛点，然而相应的人才教育培训体系却没有建立起来，导致人才问题将成为未来工业机器人发展的最大阻碍。</p><p>《制造业人才发展规划指南》指出，到2025年，高档数控机床和机器人有关领域人才缺口将达450万人，同时还指出，2020年制造业十大重点领域人才短缺将超过1900万，在2025年这个数字将近3000万。</p><p>二是核心技术太过弱势。我国是最大的工业机器人市场，但国内企业却相当弱势，这主要是缺乏核心技术的积累，同时配套能力也不够强，如高端芯片、操作系统、控制器、减速机、电机、精密加工技术等等都需要依赖进口，这些导致产品成本过高，利润不足，于是大量工业机器人企业举步艰难，发展缓慢。工信部数据显示，2020年全国规模以上工业机器人制造企业营业收入531.7亿元，利润总额17.7亿元，利润率仅3.3%。</p><p>三是产业投资太少。包括机器人企业和投资机构，各方面对工业机器人产业的投资都太少，导致产业发展缓慢，对比当年千亿万亿的资金进入互联网和移动增值行业的风潮，目前进入机器人行业的资金太少了，也就是在去年和今年才堪堪超过了百亿级别，没有资金，导致人才稀少，然后研发缓慢，由此进入恶性循环，资金缺少是工业机器人发展缓慢的一个关键点。</p><h3>2、工业机器人发展趋势</h3><p>一是提高工业机器人的智能化技术。工业机器人是先进制造业的代表，提高智能化程度可以提高工业机器人的工作能力和使用性能，推动制造业向着真正无人化、自动化的目标前进，智能化将是机器人发展的大趋势，事实上目前行业内一直在推进这方面的研究，比如将人工智能与机器人结合，还有云化机器人及工业机器人云平台等方式。</p><p>二是协作机器人成为工业机器人的重要创新方向。制造业网络化、智能化发展趋势显著，在更加复杂的离散型场景中，安全的人机协作需求不断增长，以完成更精确、更灵活的工作。传统的工业机器人需要在隔离环境中作业，极大地限制了工业机器人的应用效果和应用场景，随着技术的成熟，工业机器人的生产力和可靠性大幅提升，将会推动更加适应智能制造应用场景的协作机器人产业发展。</p>',
		},
		{
			'newid': '3',
			'title': '2022郑州工业自动化展：工业机器人产业链发展概况',
			'date': '2021-12-03 09:36',
			'substance': "工业机器人是“制造业皇冠顶端的明珠”，对其研发、制造、应用的能力，是衡量一个国家科技创新与高端制造水平的重要标志，也是未来我们迈向制造强国的必由途径，了解我国目前工业机器人处于一个什么样的水平，与国外差距如何，又存在何等难以解决的痛点，未来的发展趋势是怎样的等等问题，才能做出更加准确的决策，让有限的资源产出最大的价值，以提高整个行业在全球的竞争力。",
			'topimg': 'news3.png',
			'template': '<h3>工业机器人产业链发展概况</h3><p>工业机器人产业链主要分为上游核心零部件、中游本体制造以及下游系统集成三个环节。</p><p>上游核心零部件：包括减速器、伺服系统、控制器，直接决定了工业机器人的性能、可靠性、负载能力等主要技术指标，占工业机器人总体成本的66%。</p><p>中游本体制造：涉及工业机器人整机结构设计和加工工艺，对工业机器人的稳定、精度等也有重要影响，成本占比在25%左右。</p><p>下游系统集成：面向终端用户，根据需求实现焊接、装配、检测、搬运、喷涂等工艺或功能，成本占工业机器人整体不到10%。</p><h5>1、上游核心零部件</h5><p>上游核心零部件是工业机器人最为关键的技术，也是国内外差距最大的领域，工业机器人大型企业往往通过掌握关键零部件技术打造核心竞争力。</p><p>减速器方面：目前全球大部分市场被日本的哈默纳科（谐波减速器）、纳博特斯克（RV 减速器）所占据，比例都在7成以上，国产化率不足30%，从分类上看，谐波减速器的国产化率相对较高，而RV减速器的技术门槛较高，国产化率相对较低。</p><p>数据显示，2020年，全球机器人减速器需求量为223万台，其中谐波减速器需求量为110万台，RV减速机需求量为113万台，如果分别按均价3000元、6500元的价格测算，则2020年全球谐波减速器市场规模为33亿元，RV减速机市场规模73.45亿元，合计为106.45亿元。</p><p>伺服系统方面：伺服系统是工业机器人主要的动力来源，也是控制设备实现精确运动与定位的必要系统，一般由伺服电机、伺服驱动器、编码器三部分组成。在工业机器人伺服系统中，电机主要采用永磁同步交流伺服电机，伺服驱动主要以总线通讯形式实现对位置、速度和转矩单元的控制，编码器主要采用多圈绝对值编码器。</p><p>在伺服系统里面，伺服电机最难掌握，目前超过90%需要依赖进口，典型生产厂家有安川、西门子、三菱、松下、伦茨、路斯特等，国产的电机在技术标准、设计选料、制造工艺等多方面与国外先进水平都有较大差距，这些导致国产电机在稳定性、持久性、噪音、功率等方面都有所不足，只能用于一些低端产品。</p><p>控制器方面：控制器是根据反馈信号控制机器人的执行机构，相当于工业机器人的“大脑”。在三大部件中，控制器的技术难度相对较低，且成本占比不高，但对机器人的工作能力、操作精度、稳定性等关键指标同样有着决定性的作用。</p><p>控制器分为硬件和软件两部分，在硬件上国内外差距并不大，但在软件算法和二次开发上依然有较大差距，并且软件算法最重要的是和机器人本体相匹配，而国内大多数企业并没有完整的产业链，这就导致了国内控制器企业难以形成竞争优势，所以国产控制器的差距主要是算法和兼容性方面。</p><h5>2、中游本体制造</h5><p>中游本体制造负责工业机器人本体的组装和集成，即机座和执行机构，包括手臂、腕部等，部分还包括行走结构。</p><p>目前中游工业机器人本体制造商依然以国外“四大家族”为代表的龙头企业占据领先地位，国内相关企业体量相对较小，此前国际机械设备统计机构数据显示，全球工业机器人前十大生产商中，我国仅有埃斯顿一家入围，排名第八位，占据3.26%的市场份额。</p><p>不过在趋势上，中游环节已呈现国产替代加速的大势，MIR数据显示，国内工业机器人企业占国内市场的份额已从2018年的18%提升至2020年的29%。并且从内外资品牌出货量增长率上也可以看出这点，2021年上半年，内资同比增长109.5%，外资同比增长71%。</p><p>主要因素包括：一是本土企业价格更为灵活，性价比高且更懂国内企业需求；二是下游行业细分领域众多，市场分散、需求多样，外资企业优势并不明显；三是国内用户对国产工业机器人接受程度提高，在用工成本上升推动的“机器换人”进程中，拥有强烈的降本增效需求。</p><h5>3、下游系统集成</h5><p>机器人系统集成是连接机器人本体企业和应用端的“桥梁”，为终端客户提供应用解决方案，负责工业机器人应用的二次开发，以及周边自动化配套设备的集成，是工业机器人自动化应用的重要组成部分。</p><p>得益于我国拥有全球最完善的制造业产业类别，系统集成是机器人行业最大的市场，并随着机器人应用领域的拓展而不断增大，数据统计显示，我国机器人系统集成商已经超过了3500家，市场规模也超过了600亿元。</p><p>不过值得注意的是，机器人系统集成的技术门槛较低，竞争十分激烈，导致议价能力较弱，且在不同行业之间横向拓展困难，企业发展存在一定的瓶颈，目前国内集成商企业规模偏小，营收过亿的仅有百家左右，想要突破十分困难。</p><p>综合来看，我国的工业机器人产业链在中低端已经有一定的优势，并借此提高国产化率，同时在发展的过程中，突破工业机器人关键技术的研发应用，实现从低端向高端的渗透替代。</p><p>此外，从应用领域上看，在汽车、3C等传统行业，工业机器人的应用已经过了大规模发展的阶段，自动化程度相对较高，规模虽大需求量却较小，且大部分被国外龙头企业垄断，难以进入。反而是一般工业领域，由于企业普遍体量较小，对工业机器人的需求呈现订单分散、价格敏感、标准化低的特点，这种“长尾客户”并不是国外龙头企业的客户，反而国内工业机器人企业拥有性价比高、服务及时等本土优势，更能解决这些客户的需求，是一个相对较好的切入点。</p>',
		},
		{
			'newid': '4',
			'title': '2022郑州工业自动化展：工业机器人行业发展现状',
			'date': '2021-12-03 09:36',
			'substance': "工业机器人是“制造业皇冠顶端的明珠”，对其研发、制造、应用的能力，是衡量一个国家科技创新与高端制造水平的重要标志，也是未来我们迈向制造强国的必由途径，了解我国目前工业机器人处于一个什么样的水平，与国外差距如何，又存在何等难以解决的痛点，未来的发展趋势是怎样的等等问题，才能做出更加准确的决策，让有限的资源产出最大的价值，以提高整个行业在全球的竞争力。",
			'topimg': 'news4.png',
			'template': '<h3>工业机器人行业发展现状</h3><h5>1、定义</h5><p>工业机器人是在工业生产中使用的机器人的总称，是一种多关节机械手或多自由度的机器装置，通过编程或示教等方式，可以拥有一定的自动性，依靠自身的动力能源和控制能力，实现各种加工制造功能，替代人类完成繁重、重复、有害等各方面的工作。目前工业机器人一般可分为多关节机器人、协作机器人、Delta机器人和SCARA机器人四大类。从国内工业机器人市场销量来看，占比最高的是多关节机器人，在63%左右，其次分别为SCARA机器人、协作机器人和Delta机器人，分别约占30%、4%和3%。</p><h5>2、我国工业机器人发展历程</h5><p>我国工业机器人研究开始于20世纪70年代，直至2000年之前，行业主要以技术研究、市场探索为主，为后续的发展进行技术、人才等多方面的储备。</p><p>2000年到2010年，在汽车等主要应用领域较为低迷的情况下，国内工业机器人年均销量仅为数千台，这一阶段主要是外资在加速布局国内市场，而国内供应商主要做集成和代理。</p><p>2010年到2013年，随着下游汽车、3C等行业需求的高速增长，推动了国内工业机器人快速发展，销量开始超过万台，一些内资集成企业发展到了一定程度，开始谋求向中上游拓展。</p><h5>3、工业机器人市场情况</h5><p>全球对机器人行业的未来发展持乐观态度，此前央视财经曾报道，2020年全球机器人市场规模为250亿美元，约合人民币1600亿元，预计到2030年，该数字将扩大十倍，达到2600 亿美元，约合人民币1.7万亿元。</p><p>在今年世界机器人大会上发布的《2021中国机器人产业发展报告》显示，2021年，我国机器人市场规模预计为839亿元，其中工业机器人445.7亿元，预计到2023年，将突破589亿元；另外德邦证券研报显示，到2023年，我国工业机器人市场规模将突破100亿美元（约638亿人民币）。</p><h3>工业机器人产业链发展概况</h3><h5>1、上游核心零部件</h5><p>上游核心零部件是工业机器人最为关键的技术，也是国内外差距最大的领域，工业机器人大型企业往往通过掌握关键零部件技术打造核心竞争力。</p><p>减速器方面：目前全球大部分市场被日本的哈默纳科（谐波减速器）、纳博特斯克（RV 减速器）所占据，比例都在7成以上，国产化率不足30%，从分类上看，谐波减速器的国产化率相对较高，而RV减速器的技术门槛较高，国产化率相对较低。</p><h5>2、中游本体制造</h5><p>中游本体制造负责工业机器人本体的组装和集成，即机座和执行机构，包括手臂、腕部等，部分还包括行走结构。</p><p>目前中游工业机器人本体制造商依然以国外“四大家族”为代表的龙头企业占据领先地位，国内相关企业体量相对较小，此前国际机械设备统计机构数据显示，全球工业机器人前十大生产商中，我国仅有埃斯顿一家入围，排名第八位，占据3.26%的市场份额。</p><h5>3、下游系统集成</h5><p>机器人系统集成是连接机器人本体企业和应用端的“桥梁”，为终端客户提供应用解决方案，负责工业机器人应用的二次开发，以及周边自动化配套设备的集成，是工业机器人自动化应用的重要组成部分。</p>'
		},
	]],
    
	'ProductList': [[
		{
			'productid': '1',
			'title':'自动打印贴标机',
			'imgurl': ['1.jpg'],
			'imgprqurl':'prq1.jpg',
			'template':'<h5>介绍：</h5><p>1、自动检测并处罚打印贴标作业</p><p>2、极高的打印质量及可靠性</p><p>3、即打即贴模式，彻底杜绝串码、无打印和贴标错误</p><p>4、全天候连续、告诉、全自动打印贴标</p></p>',		
		},
		{
			'productid': '2',
			'title':'在线ICT测试机',
			'imgurl': ['2.jpg'],
			'imgprqurl':'prq2.jpg',
			'template':'<h5>特点：</h5><p>1、产品定位自动抓取，</p><p>2、流入设备进行检测，不良品自动流入NGbuffer</p><p>3、定位检测精度高</p>',		
		},
		{
			'productid': '3',
			'title':'手臂式自动螺丝机',
			'imgurl': ['3.jpg'],
			'imgprqurl':'prq3.jpg',
			'template':'<h5>介绍：</h5><p>1、采用四轴机械臂自动锁螺丝</p><p>2、精度高，减少人员投入，降低人为因素出错概率</p><p>3、C/T时间及UPH速度大幅改进，提升生产效率</p>',	
		},
		{
			'productid': '4',
			'title':'Router自动取放测试',
			'imgurl': ['4.jpg'],
			'imgprqurl':'prq4.jpg',
			'template':'<h5>介绍：</h5><p>1、采用六轴机械臂自动取放料，实现ATE设备对PCB板的自动化测试</p><p>2、减少人员投入，降低人为因素造成的出错概率</p><p>3、CCD工业相机协同工作，动态抓取PCB板、严格控制PCB板进入ATE设备的偏差。</p>',		
		},
		{
			'productid': '5',
			'title':'自动贴标线上打印系统',
			'imgurl': ['5.jpg'],
			'imgprqurl':'prq5.jpg',
			'template':'<h5>介绍：</h5><p>1、串接信息系统，照工单需求实现自动打印贴标</p><p>2、已获国家专利3052302,2965355</p>',		
		},
		{
			'productid': '6',
			'title':'Run-In老化线测试系统',
			'imgurl': ['6.jpg'],
			'imgprqurl':'prq6.jpg',
			'template':'<h5>介绍：</h5><p>1、客制化Docking Port模块，配合实际需求实现全自动产品出厂前测试</p><p>2、专利导轨、电磁铁组合系统，提升测试过程稳定性</p><p>3、已获国家专利3052302/ 2965355</p><p>4、可搭配AGV系统实现无人全自动测试方案</p>',	
		},
		{
			'productid': '7',
			'title':'W/L MB自动取放测试生产线',
			'imgurl': ['7.jpg'],
			'imgprqurl':'prq7.jpg',
			'template':'<h5>介绍：</h5><p>1、本系统已获国家三项实用新型专利（32277266,3277682,3277393）</p><p>2、结合掩码箱测试设备及六轴手臂实现全自动测试</p><p>3、依据测试结果自动分捡Pass/Fail产品</p><p>4、可以选配自动换Tray机联结使用</p>',		
		},
		{
			'productid': '8',
			'title':'专利六轴贴标机系统',
			'imgurl': ['8.jpg'],
			'imgprqurl':'prq8.jpg',
			'template':'<h5>介绍：</h5><p>1、本系统已获国家三项实用新型专利（32277266/3277682/3277393）</p><p>2、模块化设计，弹性抽换多种不同规格出标机（feeder）</p><p>3、依据实际行程及C/T要求搭配机械手臂</p>',		
		},
		{
			'productid': '9',
			'title':'柔性生产线',
			'imgurl': ['9.jpg'],
			'imgprqurl':'prq9.jpg',
			'template':'<h5>介绍：</h5><p>1、柔性较大/单机互换性较大，不同产品，不同流水工序可方便做出调整</p><p>2、为产品后续升级、更换规格提供有利空间</p><p>3、产品自动化集成度高，每个工位都采用自动上料和贴付。</p><p>4、大大减少劳动力及劳动强度。</p>',		
		},
	
	  ]],
  
	'logistics': [[
		{
			'wlid': '1',
			'title': '自動化棧板高空輸送系統',
			'imgurl': ['1.jpg'],
			'imgprqurl':'prq1.jpg',
			'template':'<h5>介绍：</h5><p>1、適用家電行業，極大化利用廠房空間</p><p>2、依據產品搭配不同抓手/治具，降低人工成本、提升生產效率</p><p>3、模組化設計，可搭配堆垛/託盤回收/紙箱供給系統等，規劃完整包裝物流線</p>',
		},
		{
			'wlid': '2',
			'title': '客制化AGV物流系統集成',
			'imgurl': ['2.jpg'],
			'imgprqurl':'prq2.jpg',
			'template':'<h5>介绍：</h5><p>1、依客戶需求及現場狀況，選配潛伏/牽引/萬向/頂升/SMT車間/叉車等AGV類型</p><p>2、全自動送料/回收等功能取代單調勞動作業、降低人力需求</p><p>3、產線設備可安裝調度系統/信號拋接模組，實現自動叫料、自動送料、即時監控AGV動態、MES系統串聯等功能，進一步深化整廠自動化程度</p>',
		},
		{
			'wlid': '3',
			'title': 'SMT智慧倉儲解決方案',
			'imgurl': ['3.jpg','4.jpg','5.jpg','6.jpg'],
			'imgprqurl':'prq3.jpg',
			'template':'<h5>介绍：</h5><p>1、设备通过Web Service与客户端MES/ERP/SAP进行对接，实现数据的及时更新。</p><p>2、來料進行自动上料打印一体設備自動入倉儲</p><p>3、AGV系统与智能仓储通过Web Service对接，物料从仓储的直接出料，并通过AGV小，实现物料到线边的无人化配送。</p><p>4、尾料部分通過LCR量测计数分料贴标一体設備再次自動入庫，</p><p>5、自动仓储系统物料识别，快速备料，分料，无人搬运车送料，物料進行先進先出管理。</p>',
		},
		{
			'wlid': '4',
			'title': 'ASRS系統',
			'imgurl': ['7.jpg'],
			'imgprqurl':'prq4.jpg',
			'template':'<h5>介绍：</h5><p>1、結合料架、高速堆垛機及WMS系統，實現節省空間、高速存取之效益</p><p>2、模組化設計便於擴充，操作機維護簡易</p><p>3、執行嚴格的工藝控制與電氣控制標準，設備穩定性、故障率低</p>',
		}
	]],
  
	'aboutzl': [[
		{
			'zlid':'1',
			'imgurl':'zl1.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'2',
			'imgurl':'zl2.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'3',
			'imgurl':'zl3.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'4',
			'imgurl':'zl4.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'5',
			'imgurl':'zl5.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'6',
			'imgurl':'zl6.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'7',
			'imgurl':'zl7.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'8',
			'imgurl':'zl8.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'9',
			'imgurl':'zl9.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'10',
			'imgurl':'zl10.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'11',
			'imgurl':'zl11.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'12',
			'imgurl':'zl12.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'13',
			'imgurl':'zl13.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'14',
			'imgurl':'zl14.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'15',
			'imgurl':'zl15.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'16',
			'imgurl':'zl16.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'17',
			'imgurl':'zl17.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'18',
			'imgurl':'zl18.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'19',
			'imgurl':'zl19.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'20',
			'imgurl':'zl20.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'21',
			'imgurl':'zl21.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'22',
			'imgurl':'zl22.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'23',
			'imgurl':'zl23.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'24',
			'imgurl':'zl24.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'25',
			'imgurl':'zl25.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'26',
			'imgurl':'zl26.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'27',
			'imgurl':'zl27.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'28',
			'imgurl':'zl28.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'29',
			'imgurl':'zl29.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'30',
			'imgurl':'zl30.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'31',
			'imgurl':'zl31.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'32',
			'imgurl':'zl32.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'33',
			'imgurl':'zl33.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'34',
			'imgurl':'zl34.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'35',
			'imgurl':'zl35.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'36',
			'imgurl':'zl36.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'37',
			'imgurl':'zl37.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'38',
			'imgurl':'zl38.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'39',
			'imgurl':'zl39.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'40',
			'imgurl':'zl40.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'41',
			'imgurl':'zl41.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'42',
			'imgurl':'zl42.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'43',
			'imgurl':'zl43.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'44',
			'imgurl':'zl44.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'45',
			'imgurl':'zl45.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'46',
			'imgurl':'zl46.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'47',
			'imgurl':'zl47.jpg',
			'text': '实用新型专利证书',
		},
		{
			'zlid':'48',
			'imgurl':'zl48.jpg',
			'text': '实用新型专利证书',
		},
	]],

	'aboutry': [[
		{
		  'ryid': '1',
		  'imgurl': 'ry1.jpg',
		  'text': '江苏省民营科技企业',
		},
		{
		  'ryid': '2',
		  'imgurl': 'ry2.jpg',
		  'text': '江苏省科技型中小企业',
		},
		{
		  'ryid': '3',
		  'imgurl': 'ry3.jpg',
		  'text': '高薪技术企业证书',
		},
	]],

	'industryCaseList': [[
		{
          'caseid': '1',
          'title': '4in1 control BD_v0p4',
          'imgurl': ['in1.jpg'],
          'casesynopsis': '降低系统测试时记忆卡的损耗取代人员测试时插拔作业的相关工时实现无人自动化作业中的记忆卡四合一模拟测试',
          'template': '',
        },
		{
          'caseid': '2',
          'title': 'SB自动测试流程',
          'imgurl': ['in2.jpg'],
          'casesynopsis': '电磁波掩码箱也称为电子波隔离箱使用本产品之前。请务必先仔细阅读本使手册，请在充分理解内容的基础上，正确使用。',
          'template': '',
        },
		{
          'caseid': '3',
          'title': '假本压设备规划书',
          'imgurl': ['in3.jpg'],
          'casesynopsis': '依超精密regulator来调整加压气缸的上升/下降之差压。（通常只调整下降压着时间以每0.1sec为单位可以做设定。Heater温度过高或过低。或heater断线时，会有alarm出现。BACKUP固定于机台上',
          'template': '',
        },
		{
          'caseid': '4',
          'title': '新型桌上型焊接机器人',
          'imgurl': ['in4.jpg'],
          'casesynopsis': '作业台部分是铝合金压铸，L型支柱是螺旋压出成形的所以结构坚固，位置重复精度高。使用宽带LCD的教导面板，焊接坐标焊接条件等一目了然，操作简单，容易学习',
          'template': '',
        },
		{
          'caseid': '5',
          'title': '天车方书案',
          'imgurl': ['in5.jpg'],
          'casesynopsis': '本设备验收后一年内，如遇故障事故，其不良原因为设计之问题者，本公司即负责维修责任，若故障因素为操作不当或为人为不良时，本公司亦负责维修责任，但客户必须承担耗损零件支费用及维修工时费',
          'template': '',
        },
		{
          'caseid': '6',
          'title': '蓝宝石基本加热平台自动取放系统',
          'imgurl': ['in6.jpg'],
          'casesynopsis': '可用4轴6轴做不同环境的作业选择机械动作相当迅速精准度高产线制作过程有变动时不会因为过程设备汰换而相对报废',
          'template': '',
        },
		{
          'caseid': '7',
          'title': 'TF覆膜机规模书',
          'imgurl': ['in7.jpg'],
          'casesynopsis': 'TF覆膜机是针对Lens覆膜贴合工艺，实现半自动生产的灵巧轻便桌上型机台。浓缩了原有大型贴合设备的复合、无气泡、速度快等特点。加入当前主流CNC雕刻机的控制原理',
          'template': '',
        },
		{
          'caseid': '8',
          'title': '覆膜设备规模书',
          'imgurl': ['in8.jpg'],
          'casesynopsis': '覆膜是针对Lens、HDD、PDA等需要贴保护膜的覆膜贴合工艺，实现半自动生产的灵巧轻便型机台，设备分为桌上型与立式机两种。浓缩了原有大型贴合设备的复合。无气泡速度快等特点。加入当前主流NC雕',
          'template': '',
        },
        {
          'caseid': '9',
          'title': '流水线自动贴标签方案',
          'imgurl': ['in9.jpg'],
          'casesynopsis': '自动流水线设计制作以及测试系统上的治具设备设计制作，并且对于设备的工厂管理系统，弘瀚有专业的SFCS软件团队，让产线设备E化方便作数据获取控管！除了研发团队在制造领域上具有丰富的实战经',
          'template': '',
        },
		{
          'caseid': '10',
          'title': '铁芯转子自动翻转机',
          'imgurl': ['in10.jpg','in11.jpg'],
          'casesynopsis': '制造业，铁芯转子自动翻转机，产品自动翻转',
          'template': '',
        },
		{
          'caseid': '11',
          'title': '服务器自动提升机',
          'imgurl': ['in12.jpg','in13.jpg'],
          'casesynopsis': '3C，服务器自动提升机，自动升降对接',
          'template': '',
        },
		{
          'caseid': '12',
          'title': '全自动铜网铜片焊接机',
          'imgurl': ['in14.jpg'],
          'casesynopsis': '散热行业-VC，全自动铜网铜片焊接机，实现铜网自送裁切，铜片自动上料，铜网+铜片自动组合后，进行自动焊接+下料。随着本设备的开发及量产，改变了行业传统生产工艺，达到省人提产保品质的效果。',
          'template': '',
        },
		{
          'caseid': '13',
          'title': '拔棒镭雕自动化设备',
          'imgurl': ['in15.jpg'],
          'casesynopsis': '散热行业-热管，拔棒镭雕自动化设备，使用自动化技术，实现铜管自动上下料、拔出铜管中的中心棒，自动激光雕刻码+刻线。本设备已开成功，且投入量产阶段，单班可节省3人，产能提升2倍。',
          'template': '',
        },
		{
          'caseid': '14',
          'title': '铜管填粉自动化',
          'imgurl': ['in16.jpg'],
          'casesynopsis': '散热行业-热管，铜管填粉自动化，使用精密机构实现精准送粉，并通过自动化做自动送粉至粉杯，震粉+注酒精一体化设计，节省人力，提高设备良率与品质。',
          'template': '',
        },
		{
          'caseid': '15',
          'title': '风扇自动组立生产线',
          'imgurl': ['in17.jpg','in18.jpg'],
          'casesynopsis': '散热风扇行业，风扇自动组立生产线，使用弘瀚柔性生产线的灵活、快换、智能的设计理念，A段设备实现PCB自动点胶&固化，线序自动检测，产品自动下料。使用弘瀚柔性生产线的灵活、快换、智能的设计理念，B段设备实现扇叶+扇框+弹簧+垫片+扣环的自动组装，检测。',
          'template': '',
        },
		{
          'caseid': '16',
          'title': '倒车雷达自动组装线',
          'imgurl': ['in19.jpg'],
          'casesynopsis': '汽车电子，倒车雷达自动组装线，改革传统生产工艺，使用自动化实现多工序的整合与自动化上料、组装、激光雕刻、测试、下料。与客户MES实时对接，进行数据互联。',
          'template': '',
        },
		{
          'caseid': '17',
          'title': '马达音圈自动组装线',
          'imgurl': ['in20.jpg','in21.jpg'],
          'casesynopsis': '成都某某光电有限公司，电子行业，马达音圈自动组装线，采用柔性线体，设备由整个生产价值链所集成，可实现自定义组织。集成有动态数字存储器、感知和通信能力，承载着在其整个供应链和生命周期中所需的各种必要信息。能够根据当前的状况灵活决定生产过程。',
          'template': '',
        },
	
      ]],
	  
    'aa': [[
		{
		  'caseid': '1',
		  'imgurl': ["in1.jpg","in2.jpg"],
		 
		},
		{
		  'caseid': '2',
		  'imgurl': ["in3.jpg","in4.jpg"],
		 
		},
		{
		  'caseid': '3',
		  'imgurl': ["in5.jpg","in6.jpg","in7.jpg","in8.jpg"],
		 
		},
		{
		  'caseid': '4',
		  'imgurl': ["in9.jpg","in10.jpg","in11.jpg","in12.jpg"],
		 
		},
  
    ]],



}


//////////////////
// WEBPACK FOOTER
// ./static/newlist.js
// module id = SWjb
// module chunks = 11